// extracted by mini-css-extract-plugin
export default {"uploadRes":"ResultPanel_uploadRes__Q5MHR","formControl":"ResultPanel_formControl__glqWB","lastFiveRes":"ResultPanel_lastFiveRes__4-MJb"};